export class Donation {
  intent: string='sale';
  payer: Payer={'payment_method': 'paypal'};
  transactions: Transaction[]=[new Transaction()];
  [others: string]: any;
}

export class FundingInstruments {
  credit_card: CardDetails=new CardDetails();
}

class Payer {
  payment_method: string='';
  [others: string]: any;
}

class Transaction {
  amount: Amount={'total': '', 'currency': '', 'details': {'subtotal': ''}};
  description: string='';
  item_list: ItemList=new ItemList;
}

class Amount {
  total: string='';
  currency: string='';
  details: AmountDetails={'subtotal': ''};
}

class AmountDetails {
  subtotal: string='';
}

class ItemList {
  items: Item[]=[new Item()];
}

export class Item {
  name: string;
  description: string;
  price: string;
  currency: string;
  tax: string;
  quantity: string;
}

class CardDetails {
  number: string='';
  type: string='visa';
  expire_month: number;
  expire_year: number;
  cvv2: number;
  first_name: string='';
  last_name: string='';
}

export class ManualDonation {
  campaign_id: string='';
  created_on: string='';
  currency: string='USD';
  donation_amount: number=0;
  converted_amount: number=0;
  email: string='';
  message: string='';
  name: string='';
  anonymous: boolean=false;
  parent_id: string='';
  response_info: {}={};
  shipping_address_1: string='';
  shipping_address_2: string='';
  shipping_country: string='United States';
  shipping_state: string='';
  shipping_city: string='';
  shipping_postal: string='';
  shipping_full: string='';
  transaction_type: string='cash';
  type: string='donation';
  merch_cart: {}={};
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/models/donation.ts